import { convert as convertActivities } from '@/activities/api/activities'
import axios, { parseCursor } from '@/base/api/axios'

export default {
  async list (filter) {
    const response = (await axios.get('/api/notifications/', { params: filter })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: convertListResults(response.results),
    }
  },

  async markClicked (id) {
    return (await axios.post(`/api/notifications/${id}/mark_clicked/`)).data
  },

  async markSeen () {
    return (await axios.post('/api/notifications/mark_seen/')).data
  },
}

function convertListResults (results) {
  return {
    notifications: results.notifications,
    activities: convertActivities(results.activities),
    issues: results.issues,
    applications: results.applications,
  }
}
